module["exports"] = [
  "福建省",
  "台灣省"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/zh_TW/address/state.js
// module id = 1735
// module chunks = 0